'use strict';

angular.module('amexReconciliationApp')
  .service('UserModel', function UserModelFactory(ModelFactory,
                                                  UserPreferencesRepository,
                                                  FeatureFlagModel) {
    var userModel = ModelFactory.create('UserModel', ['currentUser']);
    var emptyArray = [];
    userModel.isBCAManagerViewSelected = false;

    userModel.roles = function () {
      return _.get(userModel.currentUser(), 'roles', emptyArray);
    };

    userModel.bcas = function () {
      return _.get(userModel.currentUser(), 'bcas', emptyArray);
    };

    userModel.cards = function () {
      return _.get(userModel.currentUser(), 'cards', emptyArray);
    };

    userModel.managedCards = function () {
      return _.get(userModel.currentUser(), 'managedCards', emptyArray);
    };

    userModel.accountingLines = function () {
      return _.get(userModel.currentUser(), 'accountingLines', emptyArray);
    };

    userModel.isSuperAdmin = function () {
      return _.get(userModel.currentUser(), 'superAdmin', false) || userModel.previousUser !== null;
    };

    //if the role is BTA Manager returns the accounts array
      userModel.btas = function () {
          return _.get(userModel.currentUser(), 'btas', emptyArray);
      };

    userModel.setCurrentUser = function (user) {
      userModel.currentUser(user);
    };

    userModel.fetchPreferences = function (user) {
      return UserPreferencesRepository.fetch()
        .then(function (userPreferences) {
          user.preferredDateFormat = userPreferences.preferredDateFormat;
          user.preferredCurrencyFormat = userPreferences.preferredCurrencyFormat;
          user.preferredExportFields = userPreferences.exportFields;
          user.preferredSearches = userPreferences.searches;
          user.preferredPaginationSettings = userPreferences.paginationSettings;
          user.preferredTransactionColumn = userPreferences.transactionColumnPreferences;
          user.preferredLanguage = 'EN_US';
          user.allSitesColumnPreference = userPreferences.allSitesColumnPreference;
          user.email=userPreferences.email;
          user.userMigrationStatusCode=userPreferences.userMigrationStatusCode;

          if (FeatureFlagModel.languageFlag) {
            user.preferredLanguage = userPreferences.preferredLanguage;
          }

          return user;
        });
    };

    userModel.previousUser = null;
    
    userModel.currentUserPreferences = function () {
      if (!userModel.currentUser()) {
        return {
          language: '',
          dateFormat: '',
          currencyFormat: '',
          exportFields: '',
          searches: '',
          paginationSettings: '',
          transactionColumnPreferences:'',
          email:'',
          userMigrationStatusCode:''
        };
      }
      return {
        language: userModel.currentUser().preferredLanguage,
        dateFormat: userModel.currentUser().preferredDateFormat,
        currencyFormat: userModel.currentUser().preferredCurrencyFormat,
        exportFields: userModel.currentUser().preferredExportFields,
        searches: userModel.currentUser().preferredSearches,
        paginationSettings: userModel.currentUser().preferredPaginationSettings,
        transactionColumnPreferences:userModel.currentUser().preferredTransactionColumn,
        allSitesColumnPreference: userModel.currentUser().allSitesColumnPreference,
        email: userModel.currentUser().email,
        userMigrationStatusCode: userModel.currentUser().userMigrationStatusCode
      };
    };
    
    userModel.getCurrencyFormat = function() {
      if (userModel.currentUser() && userModel.currentUser().preferredCurrencyFormat) {
        return userModel.currentUser().preferredCurrencyFormat;
      }
      return 'PERIOD';
    };

    userModel.updatePreferences = function () {
      UserPreferencesRepository.save(userModel.currentUserPreferences());
    };

    return userModel;

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/UserModel.js
// module id = 597
// module chunks = 0